import MangaCard from '@/components/feature/MangaCard';
import { latestUpdates } from '@/mocks/manga';

export default function LatestUpdate() {
  return (
    <section className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日不间断更新，精彩不停歇</p>
          </div>
          <a
            href="/category/rexue"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            全部新番
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latestUpdates.map((manga) => (
            <MangaCard key={manga.id} {...manga} />
          ))}
        </div>
      </div>
    </section>
  );
}